import { BlobServiceClient } from "@azure/storage-blob";

const containerUrl = process.env.NEXT_PUBLIC_AZURE_CONTAINER_URL;
export const blobServiceClient = new BlobServiceClient(containerUrl);
